export default {
      id: "as-braille-usage",
      viewBox: "0 0 56 56",
      url: "/" + "sprite.svg#as-braille",
      toString: function () {
        return this.url;
      }
    }